import {ConsentCookieTypes, ConsentCookieUtil, CookieValues} from '../../../utils/ConsentCookieUtil';
import {CookieDisclaimerControllableComponent} from './CookieDisclaimerControllableComponent.interface';

export class CookieDisclaimerController {
  private static TIMEOUT_ON_CLOSE = 500;

  constructor(private comp: CookieDisclaimerControllableComponent) {
    // Handler functions must be bound to context 'this'!
    this.handleAcceptAll = this.handleAcceptAll.bind(this);
    this.handleAcceptSelection = this.handleAcceptSelection.bind(this);
    this.handleNoSelection = this.handleNoSelection.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  setNoCookies() {
    this.comp.personalCookies = false;
    this.comp.statisticCookies = false;
    this.comp.marketingCookies = false;
  }

  setStatisticCookies(consent) {
    this.comp.statisticCookies = !!consent;
  }

  setPersonalCookies(consent) {
    this.comp.personalCookies = !!consent;
  }

  setMarketingCookies(consent: boolean) {
    this.comp.marketingCookies = !!consent;
  }

  loadConsentStatesFromCookies() {
    if (!this.comp.forceVisible) {
      const statisticCookieVal = ConsentCookieUtil.getConsentCookie(ConsentCookieTypes.STATISTIC);
      const personalCookieVal = ConsentCookieUtil.getConsentCookie(ConsentCookieTypes.PERSONAL);
      const marketingCookieVal = ConsentCookieUtil.getConsentCookie(ConsentCookieTypes.MARKETING);

      // Falls eines der Cookies schon existiert wird das Cookie erneut gesetzt um max-age und expires zu verlängern
      if (statisticCookieVal) {
        ConsentCookieUtil.setConsentCookie(
          ConsentCookieTypes.STATISTIC,
          statisticCookieVal === CookieValues.ACCEPTED
        );
      }
      if (personalCookieVal) {
        ConsentCookieUtil.setConsentCookie(
          ConsentCookieTypes.PERSONAL,
          personalCookieVal === CookieValues.ACCEPTED
        );
      }
      if (marketingCookieVal) {
        ConsentCookieUtil.setConsentCookie(
          ConsentCookieTypes.MARKETING,
          marketingCookieVal === CookieValues.ACCEPTED
        );
      }

      // Falls eines der Cookies fehlt, muss der Dialog erneut geöffnet werden
      if (!statisticCookieVal || !personalCookieVal || !marketingCookieVal) {
        this.comp.autoVisible = true;
      }

      this.comp.statisticCookies = statisticCookieVal === CookieValues.ACCEPTED;
      this.comp.personalCookies = personalCookieVal === CookieValues.ACCEPTED;
      this.comp.marketingCookies = marketingCookieVal === CookieValues.ACCEPTED;
    }
  }

  handleAcceptAll() {
    this.comp.bahfCdAcceptAll.emit();
    this.setStatisticCookies(true);
    this.setPersonalCookies(true);
    this.setMarketingCookies(true);

    ConsentCookieUtil.setConsentCookie(ConsentCookieTypes.STATISTIC);
    ConsentCookieUtil.setConsentCookie(ConsentCookieTypes.PERSONAL);
    ConsentCookieUtil.setConsentCookie(ConsentCookieTypes.MARKETING);

    setTimeout(() => {
      this.sendConsentToDatalayer();
      this.closeModal();
    }, CookieDisclaimerController.TIMEOUT_ON_CLOSE);
  }

  handleAcceptSelection() {
    const { statisticCookies, personalCookies, marketingCookies } = this.comp;

    this.comp.bahfCdAcceptSelection.emit({
      cookieConsentChecked: statisticCookies,
      personalizationConsentChecked: personalCookies,
      marketingConsentChecked: marketingCookies,
    });

    ConsentCookieUtil.setConsentCookie(ConsentCookieTypes.STATISTIC, statisticCookies);
    ConsentCookieUtil.setConsentCookie(ConsentCookieTypes.PERSONAL, personalCookies);
    ConsentCookieUtil.setConsentCookie(ConsentCookieTypes.MARKETING, marketingCookies);

    setTimeout(() => {
      this.sendConsentToDatalayer();
      this.closeModal();
    }, CookieDisclaimerController.TIMEOUT_ON_CLOSE);
  }

  handleNoSelection() {
    this.setNoCookies();

    ConsentCookieUtil.setConsentCookie(ConsentCookieTypes.STATISTIC, false);
    ConsentCookieUtil.setConsentCookie(ConsentCookieTypes.PERSONAL, false);
    ConsentCookieUtil.setConsentCookie(ConsentCookieTypes.MARKETING, false);

    setTimeout(() => {
      this.sendConsentToDatalayer();
      this.closeModal();
    }, CookieDisclaimerController.TIMEOUT_ON_CLOSE);
  }

   // close modal without saving any user preferences. Do not send consent to data layer
   handleClose() {
    setTimeout(() => this.closeModal(), CookieDisclaimerController.TIMEOUT_ON_CLOSE);
  }

  private closeModal() {
    this.comp.autoVisible = false;
    this.comp.forceVisible = false;
  }

  private sendConsentToDatalayer() {
    const { statisticCookies, personalCookies, marketingCookies } = this.comp;
    if (window?._mtm) {
      window._mtm.push({
        event: 'set-consent',
        marketing_consent: ConsentCookieUtil.getCookieContentValue(marketingCookies),
        cookie_consent: ConsentCookieUtil.getCookieContentValue(statisticCookies),
        personalization_consent: ConsentCookieUtil.getCookieContentValue(personalCookies)
      });
    }
  }
}
